module.exports = __webpack_public_path__ + "img/gantt.e7108267.svg";